import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { authApi } from '../lib/api';
import { Loader2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

export default function AuthVerify({ type }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setError('Kein Token gefunden');
        return;
      }

      try {
        let response;
        if (type === 'admin') {
          response = await authApi.consumeAdminMagicLink(token);
        } else {
          response = await authApi.consumeHVMagicLink(token);
        }

        // Save token and user data with separate keys
        const tokenKey = type === 'admin' ? 'admin_auth_token' : 'hv_auth_token';
        localStorage.setItem(tokenKey, response.data.token);
        localStorage.setItem('user_data', JSON.stringify(response.data.user));

        toast.success('Erfolgreich eingeloggt!');

        // Redirect
        if (type === 'admin') {
          navigate('/admin');
        } else if (response.data.is_new || (() => { try { return !!localStorage.getItem('immo_onboarding_draft'); } catch { return false; } })()) {
          // New user → show onboarding as overlay over landing page
          navigate('/onboarding', { state: { backgroundLocation: { pathname: '/' } } });
        } else {
          navigate('/app');
        }
      } catch (err) {
        console.error('Auth error:', err);
        setError(err.response?.data?.detail || 'Login fehlgeschlagen. Der Link ist möglicherweise abgelaufen.');
      }
    };

    verifyToken();
  }, [token, type, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardContent className="pt-6 text-center">
            <AlertTriangle className="w-12 h-12 text-destructive mx-auto mb-4" />
            <h1 className="text-xl font-semibold mb-2">Login fehlgeschlagen</h1>
            <p className="text-muted-foreground mb-4">{error}</p>
            <Button
              onClick={() => navigate(type === 'admin' ? '/admin/login' : '/app/login')}
            >
              Erneut versuchen
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Anmeldung wird überprüft...</p>
      </div>
    </div>
  );
}
